import convertPricePerSqmToSqft from "../utils/convertPricePerSqmToSqFt";

export const NewProductCard = ({ product }) => {
  return (
    <div className="categry-explore-pro-bx">
      <a
        href={`/${product.productUrl.replace(
          "https://server.orientbell.com/",
          ""
        )}`}
      >
        <button className="quick-view-button">More Info</button>
        <div className="explore-pro-img">
          <img src={product.imageUrl[0]} alt={product.title} />
        </div>

        <div className="explore-pro-text">
          <h5>{product.title}</h5>
          {/* <p style={{ fontSize: "14px", color: "#555", marginBottom: "10px" }}>
          {product.description}
          </p> */}
          <div>
            ₹{" "}
            {product.MRP
              ? Math.round(convertPricePerSqmToSqft(product.MRP))
              : Math.round(convertPricePerSqmToSqft(product.price))}{" "}
            /- Sq.ft
          </div>
        </div>
      </a>
    </div>
  );
};
